import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

// Distinguishes which flow emitted the shared checkout_started/
// checkout_complete event names, so PostHog can segment funnels (e.g.
// paid-activation action 330258) by surface — values are a cross-system
// contract, not free-form labels.
export type CheckoutSurface = 'create' | 'reactivate' | 'promote';

@Injectable({
  providedIn: 'root',
})
export class CheckoutAnalyticsService {
  sendCheckoutStarted(planKey: string | null, surface: CheckoutSurface): void {
    posthog.capture('employer:posting_create_flow:checkout_started', {
      plan_key: planKey,
      surface,
    });
  }

  sendCheckoutComplete(planKey: string | null, surface: CheckoutSurface): void {
    posthog.capture('employer:posting_create_flow:checkout_complete', {
      plan_key: planKey,
      surface,
    });
  }
}
